<!-- iframe布局 license by http://eleadmin.com -->
<template>
  <iframe :src="src" class="ele-admin-iframe"></iframe>
</template>

<script>
  export default {
    name: 'EleIframeLayout',
    computed: {
      src() {
        return this.$route?.meta?.iframe || '';
      }
    }
  };
</script>
